import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid';

@Component({
  selector: 'app-field-actions-cell',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <div class="flex items-center justify-center h-full gap-1">
      <button
        mat-icon-button
        color="primary"
        matTooltip="Editar campo"
        [disabled]="params?.canEdit === false"
        (click)="onEditClick()">
        <mat-icon style="font-size: 20px;">edit</mat-icon>
      </button>

      <button
        mat-icon-button
        color="warn"
        matTooltip="Eliminar campo"
        [disabled]="params?.canDelete === false"
        (click)="onDeleteClick()">
        <mat-icon style="font-size: 20px;">delete_outline</mat-icon>
      </button>
    </div>
  `
})
export class FieldActionsCellComponent implements CellRenderer<any, any> {

  @Input() params!: CellRendererParams<any>;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  onEditClick(): void {
    if (this.params?.onClick) {
      this.params.onClick(this.params);
    }
  }

  onDeleteClick(): void {
    if (this.params?.onDelete) {
      this.params.onDelete(this.params);
    }
  }
}